/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceActionConstraint {
    getFixupPrototypeFunction() { return ResourceActionConstraint.fixupPrototype; }

    static newInstance(model: Partial<ResourceActionConstraint>): ResourceActionConstraint {
        let obj = Object.assign(new ResourceActionConstraint(), model);
        ResourceActionConstraint.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceActionConstraint>): ResourceActionConstraint {
        if (!model) return null;
        return ResourceActionConstraint.newInstance(<ResourceActionConstraint> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceActionConstraint) {
        if (!obj) return;

        models.ResourceActionConstraint.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceActionConstraint): boolean {
        Object.setPrototypeOf(obj, ResourceActionConstraint.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Provider-native dotted path to the resource state this rule reads, for example summary_details.instancesSet.item.instanceState.name
     */
    check_status: string;

    /**
     * Lower-cased comparison the state must satisfy for the action to be offered
     */
    condition: string;

    /**
     * State values that disable the action when matched
     */
    pop: Array<string>;

}
